(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ns-benefit-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ns-benefit-marquee')) {
    customElements.define('ns-benefit-marquee', class extends HTMLElement {
      connectedCallback() {
        const group = this.querySelector('[data-marquee-group]');
        if (!group) return;
        const pixelsPerSecond = 28;
        const measure = () => {
          if (!this.isConnected) return;
          const distance = group.getBoundingClientRect().width;
          if (distance > 0) this.style.setProperty('--ns-marquee-duration', `${distance / pixelsPerSecond}s`);
        };
        this.marqueeObserver = new ResizeObserver(measure);
        this.marqueeObserver.observe(group);
        measure();
        if (document.fonts) document.fonts.ready.then(measure);
      }
      disconnectedCallback() {
        this.marqueeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
